// For boxes with below-the-fold content, we need to constantly measure the height of that content
// to determine how far it should be pushed down.
for (let belowThefold of document.querySelectorAll('a.reveal-box .below-the-fold')) {
  let box = belowThefold.closest('.reveal-box')
  let resizeObserver = new ResizeObserver(entries => {
    box.classList.remove('below-the-fold-enabled')

    let style = getComputedStyle(entries[0].target)
    let marginTop = parseFloat(style.marginTop)
    let marginBottom = parseFloat(style.marginBottom)
    let height = entries[0].contentRect.height + marginTop + marginBottom

    box.style.setProperty('--below-the-fold-height', `${height}px`)

    setTimeout(() => {
      box.classList.add('below-the-fold-enabled')
    }, 0)
  })
  resizeObserver.observe(belowThefold)
}
